export function employees(api: ReturnType<typeof useAxios>) {
  // Employee api
  const getAllEmployee = async (data: any) =>
    await api.$get(
      `/employee?limit=${data.limit}&page=${data.page}&sort=${data.sort}&dir=${data.dir}&search=${encodeURIComponent(data.search)}&status=${data.status}`,
    );
  const createEmployee = async (data: any) =>
    await api.$post(`/employee`, data, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });
  const getEmployee = async (id: string | string[]) =>
    await api.$get(`/employee/${id}`);
  const deleteEmpoyee = async (id: string | string[]) =>
    await api.$delete(`/employee/${id}`);
  const updateEmployee = async (id: string | string[], data: any) =>
    await api.$put(`/employee/${id}`, data, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });

  // Punches api
  const employeePunch = async (data: any) =>
    await api.$post(`/employee/punch`, data);
  const getemployeePunch = async (data: any) =>
    await api.$get(
      `/employee/punch/?employee_id=${data.employee_id}&startdate=${data.fromdate}&enddate=${data.todate}`,
    );
  const getEmployeePunches = async (data: any) =>
    await api.$get(
      `/employee/punch?employee_id=${data.employee_id}&startdate=${data.fromdate}&enddate=${data.todate}&limit=${data.limit}&page=${data.page}&sort=${data.sort}&dir=${data.dir}`,
    );
  const getEmployeeOption = async () => await api.$get(`/employee/list`);
  const getApproverOption = async () =>
    await api.$get(`/employee/approver-list`);
  const updatePunch = async (data: any) =>
    await api.$put(`employee/punch/update/`, data);
  const employeeManualPunch = async (data: any) =>
    await api.$post(`/employee/manual-punch`, data);
  const deleteEmployeeManualPunch = async (id: any) =>
    await api.$delete(`/employee/delete-manual-punch/${id}`);
  // Leaves api
  const getEmployeeLeaves = async (data: any) =>
    await api.$get(
      `/employee/leave?limit=${data.limit}&page=${data.page}&sort=${data.sort}&dir=${data.dir}&search=${encodeURIComponent(data.search)}&status=${data.status}`,
    );
  const getAllEmployeeLeaves = async (data: any) =>
    await api.$get(
      `/employee/leave/all?limit=${data.limit}&page=${data.page}&sort=${data.sort}&dir=${data.dir}&search=${encodeURIComponent(data.search)}&status=${data.status}`,
    );
  const requestLeave = async (data: any) =>
    await api.$post(`/employee/leave`, data);
  const cancelLeave = async (id: string | string[], data: any) =>
    await api.$put(`/employee/leave/${id}/cancel`, data);
  const getLeave = async (id: string | string[]) =>
    await api.$get(`/employee/leave/${id}`);
  const updateLeave = async (id: string | string[], data: any) =>
    await api.$put(`/employee/leave/${id}`, data);
  const updateLeaveStatus = async (id: string | string[], data: any) =>
    await api.$put(`/employee/leave/${id}/status`, data);
  const updateEmployeeStatus = async (id: string, data: any) =>
    await api.$put(`/employee/status/${id}`, data);
  const userExist = async (data: any) =>
    await api.$post(`/employee/username-exist/`, data);
  const emailExist = async (data: any) =>
    await api.$post(`/employee/email-exist/`, data);
  const exportEmployeePunches = async (data: any) =>
    await api.file(
      `/employee/punch/report/?employee_id=${data.employee_id}&startdate=${data.fromdate}&enddate=${data.todate}`,
      {
        responseType: 'blob',
      },
    );

  const getEmployeeReport = async (data: any) =>
    await api.file(
      `/employee/excel/report?limit=${data.limit}&page=${data.page}&sort=${data.sort}&dir=${data.dir}&search=${encodeURIComponent(data.search)}`,
      {
        responseType: 'blob',
      },
    );

  const getEmployeeUsedLeaves = async (data: any) =>
    await api.$get(
      `/employee/used-leaves/${data.employee_id}/${data.year}/${data.month}`,
    );

  const getEmployeeNotifications = async (id: string) =>
    await api.$get(
      `/task/list-notification/${id}`,
    );

  const markReadEmployeeNotifications = async (id: string) =>
    await api.$get(
      `/task/read-notification/${id}`,
    );

  const getAllNotifications = async (id: string, data: any) =>
    await api.$get(`/task/list-notification-vs/${id}?limit=${data.limit}&offset=${data.offset}`);

  const saveFirebaseSubscription = async (data: any) =>
    await api.$post('/save-firebase-token', data);

  const removeFirebaseSubscription = async (data: any) =>
    await api.$post('/delete-firebase-token', data);

  return {
    getAllEmployee,
    createEmployee,
    deleteEmpoyee,
    getEmployee,
    updateEmployee,
    employeePunch,
    getEmployeePunches,
    getEmployeeOption,
    getEmployeeLeaves,
    requestLeave,
    cancelLeave,
    getLeave,
    updateLeave,
    getAllEmployeeLeaves,
    updateLeaveStatus,
    getApproverOption,
    getemployeePunch,
    updatePunch,
    employeeManualPunch,
    deleteEmployeeManualPunch,
    updateEmployeeStatus,
    userExist,
    exportEmployeePunches,
    getEmployeeReport,
    emailExist,
    getEmployeeUsedLeaves,
    getEmployeeNotifications,
    markReadEmployeeNotifications,
    getAllNotifications,
    saveFirebaseSubscription,
    removeFirebaseSubscription,
  };
}
